module.exports = __webpack_public_path__ + "static/media/delayed-from-denver.0d6a24f6.md";